/* eslint no-use-before-define: 0 */

export const InternalLinkIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      strokeMiterlimit="10"
      style={{
        fillRule: "nonzero",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      version="1.1"
      viewBox="0 0 181.44 181.44"
      xmlns="http://www.w3.org/2000/svg"
      className="sharedIcon"
    >
      <defs />
      <g id="Layer-1">
        <path
          d="M22.68 90.72L158.76 90.72"
          fill="#8d718d"
          fillRule="nonzero"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
        <path
          d="M90.72 22.68L158.76 90.72L90.72 158.76"
          fill="none"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
      </g>
    </svg>
  );
};

export const ExternalLinkIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      strokeMiterlimit="10"
      style={{
        fillRule: "nonzero",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      version="1.1"
      viewBox="0 0 181.44 181.44"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="sharedIcon"
    >
      <defs />
      <g id="Layer-1">
        <path
          d="M45.36 136.08L158.76 22.68"
          fill="#8d718d"
          fillRule="nonzero"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
        <path
          d="M45.36 136.08L158.76 22.68"
          fill="#8d718d"
          fillRule="nonzero"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
        <path
          d="M45.36 22.68L158.76 22.68L158.76 136.08"
          fill="none"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
      </g>
    </svg>
  );
};

export const DownloadLinkIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      strokeMiterlimit="10"
      style={{
        fillRule: "nonzero",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      version="1.1"
      viewBox="0 0 181.44 181.44"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="sharedIcon"
    >
      <defs />
      <g id="Layer-1">
        <path
          d="M90.72 22.68L90.72 158.76"
          fill="#8d718d"
          fillRule="nonzero"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
        <path
          d="M158.76 90.72L90.72 158.76L22.68 90.72"
          fill="none"
          opacity="1"
          // stroke="#000000"
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeWidth="16.0504"
        />
      </g>
    </svg>
  );
};

export const MoonIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{
        fillRule: "nonzero",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="sharedIcon"
    >
      <path
        d="M87.01,62.67c-14.18,6.42-31.1,3.37-42.08-7.61c-10.98-10.98-14.03-27.9-7.59-42.06c0.36-0.81,0.19-1.76-0.45-2.37  c-0.61-0.64-1.57-0.81-2.37-0.45c-4.64,2.1-8.78,4.96-12.27,8.48C14.35,26.55,10,37.05,10,48.22c0,11.15,4.35,21.64,12.25,29.55  C30.14,85.65,40.63,90,51.8,90c11.15,0,21.64-4.35,29.55-12.23c3.5-3.52,6.36-7.65,8.46-12.3c0.36-0.81,0.19-1.74-0.42-2.37  C88.75,62.48,87.82,62.29,87.01,62.67z"
        fill="#f6f6f6"
      />
    </svg>
  );
};

export const SunIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className="sharedIcon"
    >
      <path
        d="M50,27.82A22.18,22.18,0,1,0,72.18,50,22.2,22.2,0,0,0,50,27.82Z"
        // stroke="#000000"
      />
      <path
        d="M47,8.27V19.86a3,3,0,0,0,6,0V8.27a3,3,0,0,0-6,0Z"
        // stroke="#000000"
      />
      <path
        d="M50,77.14a3,3,0,0,0-3,3V91.73a3,3,0,0,0,6,0V80.14A3,3,0,0,0,50,77.14Z"
        // stroke="#000000"
      />
      <path
        d="M91.73,47H80.14a3,3,0,0,0,0,6H91.73a3,3,0,0,0,0-6Z"
        // stroke="#000000"
      />
      <path
        d="M22.86,50a3,3,0,0,0-3-3H8.27a3,3,0,0,0,0,6H19.86A3,3,0,0,0,22.86,50Z"
        // stroke="#000000"
      />
      <path
        d="M71.31,31.69a3,3,0,0,0,2.12-.88l8.2-8.2a3,3,0,0,0-4.24-4.24l-8.2,8.2a3,3,0,0,0,2.12,5.12Z"
        // stroke="#000000"
      />
      <path
        d="M26.57,69.19l-8.2,8.2a3,3,0,1,0,4.24,4.24l8.2-8.2a3,3,0,0,0-4.24-4.24Z"
        // stroke="#000000"
      />
      <path
        d="M73.43,69.19a3,3,0,0,0-4.24,4.24l8.2,8.2a3,3,0,0,0,4.24-4.24Z"
        // stroke="#000000"
      />
      <path
        d="M26.57,30.81a3,3,0,0,0,4.24-4.24l-8.2-8.2a3,3,0,0,0-4.24,4.24Z"
        // stroke="#000000"
      />
    </svg>
  );
};
